import React from 'react';
import ReactDOM from 'react-dom';
import styles from './popup.css';
import { withTheme } from 'styled-components';
import { defaultTheme } from '../../data/themes';

const popupContainerId = 'psPopup234d0234';

class Popup extends React.Component {

	constructor(props) {
		super(props);

		this.container = document.createElement("div");
		this.container.className = 'ps-popup ' + styles.popup;

		const theme = props.theme || {};


		let background = theme.popupBackground || defaultTheme.popupBackground;
		let border = theme.border || defaultTheme.border;
		let borderRadius = theme.borderRadius || defaultTheme.borderRadius;

		if (props.lookup) {
			background = theme.lookupPopupBackground || defaultTheme.lookupPopupBackground || background;
			border = theme.lookupPopupBorder || defaultTheme.lookupPopupBorder || border;
			borderRadius = theme.lookupPopupBorderRadius || defaultTheme.lookupPopupBorderRadius || borderRadius;
		}

		this.container.style.background = background;
		this.container.style.border = border;
		this.container.style.borderRadius = borderRadius;
		this.container.style.padding = theme.lookupPopupPadding || '0px';
		this.container.style.maxHeight = props.maxHeight || '38vh';

		/*
				background-color: themed('listboxBackground');
		border: themed('inputBorder');
		border-radius: themed('inputRadius');

		*/
		this.onMouseDown = this.onMouseDown.bind(this);
	}

	updatePosition() {
		const anchor = this.props.getAnchor();
		if (!anchor) {
			return;
		}
		const bottomVerticalOffset = 0;
		const topVerticalOffset = 0;
		const leftOverflow = 0;
		const rightOverflow = 0;
		const width = this.container.offsetWidth;
		const height = this.container.offsetHeight;
		const windowWidth = window.innerWidth;
		const windowHeight = window.innerHeight;
		let left, top;

		left = anchor.left - leftOverflow;
		top = anchor.bottom - 1;
		let bottom = null;

		if (top > ((windowHeight / 2) + 20)) {
		//if ((top + height + 5) > windowHeight) {
			bottom = windowHeight - anchor.top;
			top = null;
		}
		if (left > (windowWidth - width - 16)) {
			left -= left - (windowWidth - width - 16);
		}
		let minWidth = anchor.width + leftOverflow + rightOverflow;
		if (this.props.minWidth && this.props.minWidth > minWidth) {
			minWidth = this.props.minWidth;
		}
		if (top !== null) {
			this.container.setAttribute('data-inverted', '0');
		} else {
			this.container.setAttribute('data-inverted', '1');
		}

		this.width = width;
		this.height = height;
		this.container.style.left = left + 'px';
		this.container.style.top = (top !== null ? (top + bottomVerticalOffset) + 'px' : null);
		this.container.style.bottom = (bottom !== null ? (bottom + topVerticalOffset) + 'px' : null);
		this.container.style.minWidth = minWidth + 'px';
		this.container.style.visibility = 'visible';
	}

	onHideRequested() {
		if (typeof this.props.onHideRequested === 'function') {
			this.props.onHideRequested();
		}
	}

	onMouseDown = function(e) {
		let el = e.target;

		if (el !== this.container) {
			while ((el = el.parentElement)) {
				if (el === this.container) {
					return;
				}
			}
			this.onHideRequested();
		}
	}

	getPopupContainer() {
		return document.getElementById('psGuiPopupContainer');
/*		let res = document.getElementById(popupContainerId);
		if (!res) {
// <div id="popup" style="position: absolute; left: 0px; top: 0px; height:100%;"></div>
			res = document.createElement("div");
			res.setAttribute('id', popupContainerId);
			res.style.cssText = 'position: absolute; left: 0px; top: 0px; height:100%;';
			document.body.appendChild(res);
		}
		return res;*/
	}

	componentDidMount() {
		this.getPopupContainer().appendChild(this.container);
		//document.body.appendChild(this.container);
		window.setTimeout(() => {
			this.updatePosition();
		}, 0);
		document.addEventListener('mousedown', this.onMouseDown);
		//$(document).on('mousedown', this.onMouseDown);
	}

	componentDidUpdate() {
		const width = this.container.offsetWidth;
		const height = this.container.offsetHeight;
		if (Math.abs(width - this.width) > 16 || Math.abs(height - this.height) > 16) {
			this.updatePosition();
		}
	}

	componentWillUnmount() {
		//$(document).off('mousedown', this.onMouseDown);
		document.removeEventListener('mousedown', this.onMouseDown);
		this.getPopupContainer().removeChild(this.container);
		//document.body.removeChild(this.container);
	}

	render() {
		return ReactDOM.createPortal(this.props.children, this.container);
	}
}

export default withTheme(Popup);
